import { defineStore } from 'pinia'
import { useApi } from '@/api/useApi'
import { useBaseStore } from '@haskoning/vue-basestore'
import API from '@/api/apiUrls'
import type { EnvironmentDatabase, EnvironmentDatabaseUsage } from './type/environmentDatabase.type'

const serviceURL = API.BUILDING_BLOCK.ENVIRONMENT_DATABASES.INDEX

export const useEnvironmentDatabaseStore = defineStore('environmentDatabase', () => {
  const { api } = useApi()
  const baseStore = useBaseStore<EnvironmentDatabase>({ service: serviceURL, api })

  const fetchUsage = async (
    databaseId: number,
    excludeCalculationId?: number
  ): Promise<EnvironmentDatabaseUsage | null> => {
    try {
      const usageUrl = API.BUILDING_BLOCK.ENVIRONMENT_DATABASES.USAGE(
        databaseId,
        excludeCalculationId
      )
      return await api.service(usageUrl).get()
    } catch (error) {
      baseStore.setSnackbarMessage('Failed to check environmental database usage', 'error')
      console.error(error)
      return null
    }
  }

  const deleteWithContext = async (
    item: EnvironmentDatabase,
    excludeCalculationId?: number
  ): Promise<boolean> => {
    try {
      baseStore.writeLoading.value = true
      const deleteUrl = API.BUILDING_BLOCK.ENVIRONMENT_DATABASES.DELETE(
        item.id,
        excludeCalculationId
      )
      // Use the raw request so the exclude_calculation query string survives DELETE.
      await api.apiService.api(deleteUrl, 'DELETE')
      baseStore.removeItem(item)
      return true
    } finally {
      baseStore.writeLoading.value = false
    }
  }

  return {
    ...baseStore,
    fetchUsage,
    deleteWithContext
  }
})
